import React from 'react';
import {
  Card, DetailStack, FontWeight, HStack, Stack, Text,
} from '@doveit/bricks';
import { Feedback } from '../../../providers/api/dtos';
import FeedbackAvatar from '../../components/feedback-avatar/FeedbackAvatar';
import useProspect from '../../../prospect/hooks/use-prospect/useProspect';
import { FeedbackStatus, ReferenceType } from '../../../domain/types';
import ProspectPreview from '../../../prospect/components/prospect-preview/ProspectPreview';
import DateViewer from '../../../components/date-viewer/DateViewer';
import { ViewFeedbackAction } from '../view-feedback-action/ViewFeedbackAction';
import ShortRating from '../../../components/short-rating/ShortRating';
import UpdateFeedbackStatus from '../update-feedback-status/UpdateFeedbackStatus';

export interface ViewFeedbackCardProps {
  feedback: Feedback,
  canSeeFeedback?: boolean,
  canUpdateStatus?: boolean,
  onSurveyUpdated?: (feedback: Feedback) => void,
}

const ViewFeedbackCard: React.FC<ViewFeedbackCardProps> = ({
  feedback,
  onSurveyUpdated,
  canSeeFeedback = false,
  canUpdateStatus = false,
}) => {
  const { data: prospect } = useProspect(feedback.reference?.type === ReferenceType.PROSPECT
    ? feedback.reference.id
    : undefined);

  return (
    <Card>
      <Card.Header
        primaryActions={[
          canSeeFeedback && [FeedbackStatus.COMPLETED, FeedbackStatus.REVIEWED].includes(feedback.status) && (
            <ViewFeedbackAction
              feedback={feedback}
              size="S"
              onSuccess={onSurveyUpdated}
              canEdit
            />
          ),
        ]}
      >
        <HStack gap={100} wrap="nowrap">
          <FeedbackAvatar size="S" />
          <Text.Body fontWeight={FontWeight.MEDIUM}>
            {feedback.survey?.name || 'Survey'}
          </Text.Body>
        </HStack>
      </Card.Header>
      <Card.Content>
        <Stack gap={150}>
          <div aria-label="Stato">
            <UpdateFeedbackStatus
              feedback={feedback}
              size="XS"
              emphasis="low"
              onSuccess={onSurveyUpdated}
              showAsBadge={!canUpdateStatus}
            />
          </div>

          {prospect && (
            <ProspectPreview prospect={prospect} />
          )}

          {feedback.survey?.submittedAt && (
            <HStack
              gap={50}
              wrap="nowrap"
              justifyContent="space-between"
            >
              <DetailStack label="Compilata">
                <DateViewer
                  stringDate={feedback.survey.submittedAt}
                  checkIfToday
                  withHour
                />
              </DetailStack>

              <ShortRating score={feedback.survey.score} />
            </HStack>
          )}
        </Stack>
      </Card.Content>
    </Card>
  );
};

export default ViewFeedbackCard;
